// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"25": "lib-axios","26": "lib-router",}[chunkId] || chunkId) + ".js"
}